import React from 'react'
import styles from './EmailInput.module.css'

interface EmailInputProps {
  value: string
  onChange: (value: string) => void
  error?: string
  placeholder?: string
  disabled?: boolean
  label?: string
  onBlur?: () => void
}

const EmailInput: React.FC<EmailInputProps> = ({
  value,
  onChange,
  error,
  placeholder = 'Email',
  disabled = false,
  label,
  onBlur,
}) => {
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Дозволяємо всі символи для email
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Home',
      'End',
    ]

    // Дозволяємо всі Ctrl/Cmd комбінації (copy, paste, select all, etc.)
    const isModifierKey = (e.ctrlKey || e.metaKey) && e.key.length === 1

    // Дозволяємо всі символи крім спеціальних клавіш
    const isAllowedKey =
      allowedKeys.includes(e.key) || 
      isModifierKey || 
      (e.key.length === 1 && !e.ctrlKey && !e.metaKey)

    if (!isAllowedKey) {
      e.preventDefault()
    }
  }

  return (
    <div className={styles.emailInputContainer}>
      <div className={`${styles.inputField} ${error ? styles.errorInput : ''}`}>
        <div className={styles.fieldWrap}>
          {label && <label className={styles.fieldLabel}>{label}</label>}

          <div className={`${styles.emailInput} ${error ? styles.emailInputError : ''}`}>
            <input
              type="email"
              value={value}
              onChange={handleEmailChange}
              onKeyDown={handleKeyDown}
              onBlur={onBlur}
              className={`${styles.emailInputField} ${error ? styles.emailInputFieldError : ''}`}
              placeholder=""
              disabled={disabled}
              required
            />
          </div>
        </div>
      </div>

      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  )
}

export default EmailInput
